<template>
  <div style="width:100%;padding-top:30px">
    <v-layout>
      <v-flex xs3>
        <v-card
            class="mx-auto"
            width="250"
          >
            <v-list dense>
              <v-list-item>
                <v-list-item-content>

                  <v-text-field
                    v-model="table.search"
                    label="Name / OSIS / Email"
                    :hide-details="true"
                    placeholder="Search..."
                    >
                  </v-text-field>
                </v-list-item-content>
                <v-list-item-action>
                        <v-btn icon>
                          <v-icon color="grey lighten-1">search</v-icon>
                        </v-btn>
                      </v-list-item-action>
              </v-list-item>
              <v-list-item
                  v-for="(group, i) in groups"
                  :key="i"
                  link
                  @click="selectGroup(group)"
                >
                <v-list-item-title v-text="group.name"></v-list-item-title>
                <span style="font-size:.8em">{{ group.num_students }}</span>
              </v-list-item>
            </v-list>
          </v-card>
      </v-flex>
      <v-flex xs9>
        <v-data-table
          :headers="table.headers"
          :items="items"
          :dense="true"
          :search="table.search"
          :sort-by="['last_name']"
          :hide-default-footer="true"
          :disable-pagination="true"
          :height="700"
        >
        <template v-slot:item="props">
          <tr>
            <td style="font-size:.8em" class="text-xs">
              {{ props.item.first_name }}
            </td>
            <td style="font-size:.8em" class="text-xs">
              {{ props.item.last_name }}
            </td>
            <td style="font-size:.8em" class="text-xs">
              {{ props.item.uid }}
            </td>
            <td style="font-size:.8em" class="text-xs">
              {{ props.item.email ? props.item.email.indexOf("@") ? props.item.email.split("@")[0] : props.item.email : ''}}
            </td>
            <td style="font-size:.8em">
              {{ props.item.class_of }}
            </td>
            <td class="text-xs-center">
            </td>

          </tr>
          </template>
        </v-data-table>
      </v-flex>
    </v-layout>
  </div>
</template>

<script>
const api = require('../apiFunctions.js')
const fb = require('../firebaseConfig.js')

export default {
  data: () => ({
    user: fb.session.user,

    groups: [],
    params: {
      user_uid: '',
      target: '',
      table: '',
      limit: 100
    },
    items: [],
    table: {
      search: '',
      headers: [
        { text: 'First', value: 'first_name' },
        { text: 'Last', value: 'last_name' },
        { text: 'OSIS', value: 'uid' },
        { text: 'Email', value: 'email' },
        { text: 'Class Of', value: 'class_of' },
        { text: '', value: '' }
      ]
    }
  }),
  watch: {
  },
  mounted () {
    var self = this
    self.groups.push({
      name:'All Active',
      classOf: null,
      num_students: 0
    })
    api.get('getStudentGroups', {}, (data) => {
      console.log(data)
      data.forEach((item, i) => {
        console.log(item)
        item.classOf = item.name
        self.groups.push(item)
        self.groups[0].num_students += item.num_students
      });
    })
  },
  methods: {
    selectGroup: function (group) {
      var self = this
      api.get('dbStudents', {classOf:group.classOf}, (data) => {
        console.log(data)
        self.items = data
      })
    },
    viewClasses: function (student) {
      console.log(student)
      this.$router.push({ path: '/classes/all', query: { studentId: student.primaryEmail }})
    },
    search: function () {
      var self = this
      console.log(this.params)
      api.students.get(this.params, (data) => {
        console.log(data)
        self.items = data
      })
    }
  }
}
</script>
